import { Heading4 } from "@/components/text/Heading4";
import { NormalText } from "@/components/text/NormalText";

export function OpenArtistModalStep() {
  return (
    <div>
      <Heading4 elementType="h3" className="mb-2">
        Select Your Artist
      </Heading4>
      <NormalText elementType="p" className="text-sm">
        Click here to select an artist to sing your vocal.
      </NormalText>
    </div>
  );
}
